import React from "react";
import stl from "./od-os.module.scss";
import { useCommonContext } from "@/src/provider";
import { FmImage } from "@/ui-component";

type SphHelpProps = {
    title: string;
    description: string;
    video?: string;
    image?: string;
};

const Help: React.FC<SphHelpProps> = (props) => {
    return (
        <div>
            {props.video && (
                <div style={{ maxHeight: "4.46rem" }}>
                    <video
                        width="100%"
                        height="auto"
                        controls
                        x5-playsinline={true.toString()}
                        webkit-playsinline="true"
                        // autoPlay
                        src={props.video}
                    />
                </div>
            )}
            {props.image && (
                <FmImage width="310" height="215" image={props.image} />
            )}
            <div className={stl["rx-form-help-title"]}>{props.title}</div>
            <p className={stl["rx-form-help-p"]}>{props.description}</p>
        </div>
    );
};

export default Help;
